var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDetails = function SvgDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.044 2.008a6.556 6.556 0 0 0-9.442 0c-2.381 2.448-2.617 6.335-.55 9.069L.242 16.02a.87.87 0 0 0 0 1.207.814.814 0 0 0 1.174 0l4.809-4.944c2.784 2.225 6.77 1.84 9.104-.878 2.332-2.719 2.208-6.834-.286-9.397Zm-1.174 8.501a4.926 4.926 0 0 1-7.093.001h-.002C5.341 9.033 4.911 6.814 5.688 4.886c.776-1.928 2.606-3.185 4.635-3.185 2.03 0 3.858 1.257 4.635 3.185.776 1.928.347 4.147-1.088 5.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.604 6.01h-1.451V4.518a.842.842 0 0 0-.83-.853.842.842 0 0 0-.83.853V6.01H8.042a.842.842 0 0 0-.83.854c0 .471.371.854.83.854h1.45V9.21c0 .471.372.853.83.853.46 0 .83-.382.83-.853V7.718h1.452c.458 0 .83-.383.83-.854a.842.842 0 0 0-.83-.854Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/details.366b7797.svg";
export { ForwardRef as ReactComponent };